(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("lyuNc"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("243E2"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("iroH5"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("a0HkP"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("lnhyD"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("iXl0S"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("lyuNc", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "battery-charging.ba1b1745.webp";

});

parcelRegister("243E2", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "settings-02.d69d69bd.webp";

});

parcelRegister("iroH5", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "life-buoy.285e728c.webp";

});

parcelRegister("a0HkP", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "people.d532b8d6.webp";

});

parcelRegister("lnhyD", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "grid.f0e29351.webp";

});

parcelRegister("iXl0S", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "box.2a34708a.webp";

});


parcelRegister("5iqNH", function(module, exports) {

var $8Ay3m = parcelRequire("8Ay3m");
const $3db36c35411957e8$var$testimonialCardParent = document.querySelector(".swiper-wrapper.testimonial-cards");
(0, $8Ay3m.default).forEach((testimonial)=>{
    const testimonialCardEl = document.querySelector('[data-element="testimonial-card-slider"]').cloneNode(true);
    testimonialCardEl.querySelector('[data-element="testimonial-people-name"]').textContent = testimonial.name;
    testimonialCardEl.querySelector('[data-element="testimonial-position"]').textContent = testimonial.position;
    testimonialCardEl.querySelector('[data-element="testimonial-text-all"]').innerHTML = testimonial.testimonyTextAll;
    testimonialCardEl.querySelector('[data-element="testimonial-text-less"]').innerHTML = testimonial.testimonyTextLess ?? testimonial.testimonyText;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').src = testimonial.companyLogo;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').parentElement.classList.add(testimonial.companyLogoClass);
    testimonialCardEl.querySelector('[data-element="testimonial-photo-small"]').srcset = testimonial.photo.mobile;
    testimonialCardEl.querySelector('[data-element="testimonial-photo-large"]').src = testimonial.photo.desktop;
    $3db36c35411957e8$var$testimonialCardParent.appendChild(testimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-card-slider"]')[0].remove();
document.querySelectorAll(".testimonial-content .showMoreBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "inline";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "none";
    });
});
document.querySelectorAll(".testimonial-content .showLessBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "none";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "inline";
    });
});

});
parcelRegister("8Ay3m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $640c19c59862cd3c$export$2e2bcd8739ae039; });




























const $640c19c59862cd3c$var$testimonials = [
    {
        name: "Neo Christodoulou",
        photo: {
            mobile: new URL((parcelRequire("dajRr"))),
            tablet: new URL((parcelRequire("asi2V"))),
            desktop: new URL((parcelRequire("asi2V")))
        },
        position: "Founder, Smashing Plates",
        companyLogo: new URL((parcelRequire("5R4dE"))),
        companyLogoClass: "smashing-plates",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "Johnny Smith and Daniel Willis",
        photo: {
            mobile: new URL((parcelRequire("f5rxU"))),
            tablet: new URL((parcelRequire("195jo"))),
            desktop: new URL((parcelRequire("195jo")))
        },
        position: "Co Founder, Luca Restaurant",
        companyLogo: new URL((parcelRequire("1v7Bi"))),
        companyLogoClass: "luca",
        testimonyText: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations."
    },
    {
        name: "Wonchul Park",
        photo: {
            mobile: new URL((parcelRequire("cVzsa"))),
            tablet: new URL((parcelRequire("gAFYt"))),
            desktop: new URL((parcelRequire("gAFYt")))
        },
        position: "Michelin Star Chef, Sollip",
        companyLogo: new URL((parcelRequire("2CfsK"))),
        companyLogoClass: "sollip",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "George\xa0Kakavitsa",
        photo: {
            mobile: new URL((parcelRequire("diaQb"))),
            tablet: new URL((parcelRequire("3vkxG"))),
            desktop: new URL((parcelRequire("3vkxG")))
        },
        position: "Assistant Restaurant Manager, L\xedo London",
        companyLogo: new URL((parcelRequire("cvISv"))),
        companyLogoClass: "lio",
        testimonyText: "Wenodo's HR/Rota SaaS solution has revolutionized our workforce management. Its intuitive interface simplifies employee's lifecycle, shift scheduling and communication. With robust reporting, we gain valuable insights for informed decisions. Exceptional customer support ensures smooth operations. It's a game-changer for our Restaurant operation, enhancing efficiency and employee engagement. Highly recommended!"
    },
    {
        name: "Dominic Hamdy",
        photo: {
            mobile: new URL((parcelRequire("6kQIE"))),
            tablet: new URL((parcelRequire("lGmbT"))),
            desktop: new URL((parcelRequire("lGmbT")))
        },
        position: "Founder, HAM Restaurants",
        companyLogo: new URL((parcelRequire("eCzgg"))),
        companyLogoClass: "ham",
        testimonyText: "WENODO has helped to grow and streamline our business from day one. We can now make financial and strategic decisions based on data we can trust. Their personal attitude and enthusiasm to go the extra mile is invaluable, but it's their modern approach to accounting that has \xa0propelled us forward.\xa0"
    },
    // {
    //   name: 'Tarek Farah',
    //   photo: {
    //     mobile: new URL('../image/testimonial-tarek-farah-mobile.png?as=webp', import.meta.url),
    //     tablet: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url),
    //     desktop: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url)
    //   },
    //   position: 'Founder and CEO, Aline Lebanese Kitchen',
    //   companyLogo: new URL(
    //     '../image/aline-company.png',
    //     import.meta.url
    //   ),
    //   companyLogoClass: 'aline',
    //   testimonyText: 'I have been gladly working with the Wenodo team for nearly 10 years. They are not just professional, experienced, and knowledgeable accountants but also great consultants who offer so much value and advice on all levels of hospitality. I cannot imagine any of our future projects being developed without Wenodo by our side!'
    // },
    {
        name: "David Bellaiche",
        photo: {
            mobile: new URL((parcelRequire("1Ns1w"))),
            tablet: new URL((parcelRequire("j43Xu"))),
            desktop: new URL((parcelRequire("j43Xu")))
        },
        position: "Co-Founder, NAC London",
        companyLogo: new URL((parcelRequire("ci3UZ"))),
        companyLogoClass: "nac",
        testimonyText: "Wenodo's daily, weekly, and monthly KPIs and analytics has been so critical for our business. Their insightful Dashboard and reports have allowed us to maximize profits. With these detailed metrics, we're empowered to make timely and informed decisions, contributing significantly to\xa0our\xa0success."
    },
    {
        name: "Gabriel Cohen-Elia",
        photo: {
            mobile: new URL((parcelRequire("fKUqZ"))),
            tablet: new URL((parcelRequire("4AUa9"))),
            desktop: new URL((parcelRequire("4AUa9")))
        },
        position: "Co-Founder, Cr\xe8me London",
        companyLogo: new URL((parcelRequire("hMrVp"))),
        companyLogoClass: "creme",
        testimonyText: "Partnering with Wenodo has revolutionized how we manage our finances and operations. Their specialized accounting and bookkeeping solutions have not only streamlined our processes but also brought unparalleled clarity to our financial landscape. Wenodo's dedicated support team is always responsive and knowledgeable, making them an integral part of our success. For anyone in hospitality seeking reliability and expertise, Wenodo is the\xa0clear\xa0choice."
    }
];
var $640c19c59862cd3c$export$2e2bcd8739ae039 = $640c19c59862cd3c$var$testimonials;

});
parcelRegister("dajRr", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimoni-neo-mobile.63e4b5d3.webp";

});

parcelRegister("asi2V", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimoni-neo.dcffeccd.webp";

});

parcelRegister("5R4dE", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "smashing-plates.7136aa41.webp";

});

parcelRegister("f5rxU", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimoni-johny-mobile.dfee8b00.webp";

});

parcelRegister("195jo", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimoni-johny.331dada6.webp";

});

parcelRegister("1v7Bi", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "luca-company.ebbca258.webp";

});

parcelRegister("cVzsa", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-wonchul-mobile.82623782.webp";

});

parcelRegister("gAFYt", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-wonchul.e435ed72.webp";

});

parcelRegister("2CfsK", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "sollip-company.c4e68d8a.png";

});

parcelRegister("diaQb", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-george-mobile.ba4357c1.webp";

});

parcelRegister("3vkxG", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-george.3f5b8295.webp";

});

parcelRegister("cvISv", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "lio-company.51d21251.png";

});

parcelRegister("6kQIE", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-dominic-hamdy-mobile.795bc261.webp";

});

parcelRegister("lGmbT", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-dominic-hamdy.7a029c2b.webp";

});

parcelRegister("eCzgg", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "ham-company.5f8ce858.png";

});

parcelRegister("1Ns1w", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-david-bellaiche-mobile.c3669d3d.webp";

});

parcelRegister("j43Xu", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-david-bellaiche.e487dcaf.webp";

});

parcelRegister("ci3UZ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "nac-company.269e0029.png";

});

parcelRegister("fKUqZ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-gabriel-mobile.45a97971.webp";

});

parcelRegister("4AUa9", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "testimonial-gabriel.ad41ee07.webp";

});

parcelRegister("hMrVp", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("8WzKa") + "creme-company.ca71e074.png";

});



parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $bc981c5383294ea9$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("8WzKa"), JSON.parse('["8WzKa","all-product.4f4b8278.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","1BQWm","people.d532b8d6.webp","eSkdY","grid.f0e29351.webp","9Glg9","box.2a34708a.webp","8XsBo","testimoni-neo-mobile.63e4b5d3.webp","4ho8f","testimoni-neo.dcffeccd.webp","hLnjK","smashing-plates.7136aa41.webp","lORrT","testimoni-johny-mobile.dfee8b00.webp","5pWvc","testimoni-johny.331dada6.webp","e7lNY","luca-company.ebbca258.webp","cDWBZ","testimonial-wonchul-mobile.82623782.webp","3V7nb","testimonial-wonchul.e435ed72.webp","jp2ug","sollip-company.c4e68d8a.png","3v0AM","testimonial-george-mobile.ba4357c1.webp","991Ub","testimonial-george.3f5b8295.webp","3ZUyT","lio-company.51d21251.png","cqGH0","testimonial-dominic-hamdy-mobile.795bc261.webp","3WiP9","testimonial-dominic-hamdy.7a029c2b.webp","eba0Q","ham-company.5f8ce858.png","e5FYN","testimonial-david-bellaiche-mobile.c3669d3d.webp","iQoFg","testimonial-david-bellaiche.e487dcaf.webp","isBg7","nac-company.269e0029.png","7yGuJ","testimonial-gabriel-mobile.45a97971.webp","774bJ","testimonial-gabriel.ad41ee07.webp","tTeKh","creme-company.ca71e074.png"]'));

parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("5iqNH");
parcelRequire("2SvjK");
/* eslint-disable no-undef */ // eslint-disable-next-line no-unused-vars
const $ca5a1e189d7eccef$var$swiper = new Swiper(".swiper-testimonial", {
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-testimonial-next-button",
        prevEl: ".swiper-testimonial-prev-button"
    },
    breakpoints: {
        1200: {
            slidesPerView: 1.2
        }
    }
});
const $ca5a1e189d7eccef$var$isLarge = window.matchMedia("(min-width: 1200px)");
if ($ca5a1e189d7eccef$var$isLarge.matches) // Then trigger an alert
$ca5a1e189d7eccef$var$swiper.on("slideChange", function() {
    if ($ca5a1e189d7eccef$var$swiper.activeIndex === 0) document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "-8.25%";
    else if ($ca5a1e189d7eccef$var$swiper.activeIndex === 1) {
        document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "auto";
        document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "auto";
    } else if ($ca5a1e189d7eccef$var$swiper.activeIndex === 2) document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "-8.25%";
});
const $ca5a1e189d7eccef$var$availableProductsEl = document.querySelector(".available-products");
$ca5a1e189d7eccef$var$availableProductsEl.querySelectorAll(".available-products--tabButton").forEach((tabElement)=>{
    tabElement.addEventListener("click", ()=>{
        $ca5a1e189d7eccef$var$availableProductsEl.querySelectorAll(".available-products--tabButton").forEach((el)=>{
            el.classList.remove("active");
        });
        $ca5a1e189d7eccef$var$availableProductsEl.querySelectorAll(".available-products--content-item").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "flex";
        });
        console.log(tabElement.getAttribute("data-tab"));
        tabElement.classList.add("active");
    });
});
const $ca5a1e189d7eccef$var$pricingPlanEl = document.querySelector(".pricing-plan");
$ca5a1e189d7eccef$var$pricingPlanEl.querySelectorAll(".pricing-plan--tab-button").forEach((tabElement)=>{
    tabElement.addEventListener("click", ()=>{
        $ca5a1e189d7eccef$var$pricingPlanEl.querySelectorAll(".pricing-plan--tab-button").forEach((el)=>{
            el.classList.remove("active");
        });
        $ca5a1e189d7eccef$var$pricingPlanEl.querySelectorAll(".pricing-plan--content").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "flex";
        });
        console.log(tabElement.getAttribute("data-tab"));
        tabElement.classList.add("active");
    });
});
const $ca5a1e189d7eccef$var$preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`;
document.querySelector(".pricing-plan--preHeadingIcon").innerHTML += $ca5a1e189d7eccef$var$preHeadingIcon;
document.querySelector(".apps__allProduct--left-preHeading-icon").innerHTML += $ca5a1e189d7eccef$var$preHeadingIcon;
document.querySelector(".testimonial-slider-preHeading .services__icon").innerHTML += $ca5a1e189d7eccef$var$preHeadingIcon;
// Arrow Up Icon Button
const $ca5a1e189d7eccef$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
// document.querySelector('.btn-learn-more').innerHTML += arrowUpIcon
document.querySelectorAll(".btn.btn-book-demo").forEach((el)=>{
    el.innerHTML += $ca5a1e189d7eccef$var$arrowUpIcon;
});
const $ca5a1e189d7eccef$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $ca5a1e189d7eccef$var$chevronDownIcon;
});
const $ca5a1e189d7eccef$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $ca5a1e189d7eccef$var$hamburgerIcon;
// Create the observer like the examples above
const $ca5a1e189d7eccef$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $ca5a1e189d7eccef$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$ca5a1e189d7eccef$var$squares.forEach((element)=>$ca5a1e189d7eccef$var$observer.observe(element));
// Dropdown Pricing
const $ca5a1e189d7eccef$var$dropdownPricing = document.querySelector('[data-element="dropdown-pricing"]');
$ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-btn"]').addEventListener("click", (el)=>{
    if ($ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-content"]').classList.contains("hide")) {
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-content"]').classList.remove("hide");
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "180deg";
    } else {
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
    }
});
$ca5a1e189d7eccef$var$dropdownPricing.querySelectorAll('[data-element="dropdown-btn-item"]').forEach((el)=>{
    el.addEventListener("click", (ev)=>{
        const textSelection = el.querySelector("p").textContent;
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-btn"] p').textContent = textSelection;
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $ca5a1e189d7eccef$var$dropdownPricing.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
        $ca5a1e189d7eccef$var$pricingPlanEl.querySelectorAll(".pricing-plan--content").forEach((elContent)=>{
            elContent.style.display = "none";
            if (el.getAttribute("data-select") === elContent.getAttribute("data-tab")) elContent.style.display = "flex";
        });
    });
});
// Dropdown Product
const $ca5a1e189d7eccef$var$dropdownProduct = document.querySelector('[data-element="dropdown-product"]');
$ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-btn"]').addEventListener("click", (el)=>{
    if ($ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.contains("hide")) {
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.remove("hide");
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "180deg";
    } else {
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
    }
});
$ca5a1e189d7eccef$var$dropdownProduct.querySelectorAll('[data-element="dropdown-btn-item"]').forEach((elBtn)=>{
    elBtn.addEventListener("click", (ev)=>{
        const textSelection = elBtn.querySelector("p").textContent;
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-btn"] p').textContent = textSelection;
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $ca5a1e189d7eccef$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
        $ca5a1e189d7eccef$var$availableProductsEl.querySelectorAll(".available-products--content-item").forEach((elContent)=>{
            elContent.style.display = "none";
            if (elBtn.getAttribute("data-select") === elContent.getAttribute("data-tab")) elContent.style.display = "flex";
        });
    });
});
if (window.location.hash) document.querySelector(window.location.hash).scrollIntoView({
    behavior: "smooth"
});
document.addEventListener("DOMContentLoaded", async function() {
    const currencySelected = document.querySelector(".currency--selected");
    const currencyOptions = document.getElementById("currency-options");
    const arrowCurrency = document.getElementById("chevron-currency");
    const currencyCodeSelected = document.getElementById("currency-code--selected");
    const currencyFlagSelected = document.getElementById("flag--selected");
    const basicPriceElement = document.getElementById("basic-pricing");
    const premiumPriceElement = document.getElementById("premium-pricing");
    currencySelected.addEventListener("click", function() {
        currencyOptions.classList.toggle("show");
        arrowCurrency.classList.toggle("rotate-180");
    });
    const updatePrices = (currency)=>{
        const prices = {
            usd: {
                basic: 2.49,
                premium: 3.49
            },
            aed: {
                basic: 10,
                premium: 12
            },
            gbp: {
                basic: 1.99,
                premium: 2.49
            }
        };
        const symbols = {
            usd: "$",
            aed: "AED",
            gbp: "\xa3"
        };
        const { basic: basic, premium: premium } = prices[currency] || prices.usd;
        const symbol = symbols[currency] || symbols.usd;
        basicPriceElement.textContent = `${symbol} ${basic}`;
        premiumPriceElement.textContent = `${symbol} ${premium}`;
    };
    function updateCurrencySelection(currency, flagUrl, currencyText) {
        console.log("Currency Selected:", currency);
        currencyCodeSelected.textContent = currencyText;
        currencyFlagSelected.setAttribute("src", flagUrl);
        updatePrices(currency);
        currencyOptions.classList.remove("show");
        arrowCurrency.classList.remove("rotate-180");
    }
    document.getElementById("usd").addEventListener("click", ()=>{
        updateCurrencySelection("usd", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/us_qwpozj.svg", "USD");
    });
    document.getElementById("aed").addEventListener("click", ()=>{
        updateCurrencySelection("aed", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/ae_irineu.svg", "AED");
    });
    document.getElementById("gb").addEventListener("click", ()=>{
        updateCurrencySelection("gbp", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/gb_onty7y.svg", "GBP");
    });
    try {
        const initialCurrency = await $ca5a1e189d7eccef$var$switchCurrencyBasedOnUserLocation();
        const initialCurrencyLower = initialCurrency.toLowerCase();
        switch(initialCurrencyLower){
            case "aed":
                updateCurrencySelection("aed", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/ae_irineu.svg", "AED");
                break;
            case "gbp":
                updateCurrencySelection("gbp", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/gb_onty7y.svg", "GBP");
                break;
            case "usd":
            default:
                updateCurrencySelection("usd", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/us_qwpozj.svg", "USD");
                break;
        }
    } catch (error) {
        console.error("Error fetching location or currency information:", error);
        updateCurrencySelection("usd", "https://res.cloudinary.com/dyzgkxmn1/image/upload/v1723086784/flags/us_qwpozj.svg", "USD");
    }
});
async function $ca5a1e189d7eccef$var$switchCurrencyBasedOnUserLocation() {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const countryCode = data.country_code;
    switch(countryCode){
        case "AE":
            return "AED";
        case "GB":
            return "GBP";
        default:
            return "USD";
    }
}

})();
//# sourceMappingURL=all-product.4f4b8278.js.map
